"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@uppy/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toArray = function toArray(list) {
  return Array.prototype.slice.call(list || [], 0);
};

var SingleFileUppy = /*#__PURE__*/function (_React$Component) {
  _inherits(SingleFileUppy, _React$Component);

  var _super = _createSuper(SingleFileUppy);

  function SingleFileUppy() {
    var _this;

    _classCallCheck(this, SingleFileUppy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      uploading: false,
      progress: 0
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (ev) {
      var uppy = _this.props.uppy;
      uppy.log('[SingleFileUppy] Something selected through input...');
      var files = toArray(ev.target.files);
      files.forEach(function (file) {
        try {
          uppy.addFile({
            // source: this.id,
            name: file.name,
            type: file.type,
            data: file
          });
        } catch (err) {// Nothing, restriction errors handled in Core
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "startUpload", function () {
      var uppy = _this.props.uppy;
      uppy.reset();

      _this.input.click();
    });

    return _this;
  }

  _createClass(SingleFileUppy, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var _this$props = this.props,
          uppy = _this$props.uppy,
          onChange = _this$props.onChange;
      uppy.on('upload', function () {
        _this2.setState({
          uploading: true
        });

        onChange(_objectSpread(_objectSpread({}, _this2.state), {}, {
          uploading: true
        }));
      });
      uppy.on('complete', function () {
        _this2.setState({
          uploading: false
        });

        onChange(_objectSpread(_objectSpread({}, _this2.state), {}, {
          uploading: false
        }));
      });
      uppy.on('upload-progress', function (upload, _ref) {
        var bytesTotal = _ref.bytesTotal,
            bytesUploaded = _ref.bytesUploaded;
        var p = Math.round(bytesUploaded / bytesTotal * 100);

        _this2.setState({
          progress: p
        });

        onChange(_objectSpread(_objectSpread({}, _this2.state), {}, {
          progress: p
        }));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          uppy = _this$props2.uppy;
      var _this$state = this.state,
          uploading = _this$state.uploading,
          progress = _this$state.progress;
      /* http://tympanus.net/codrops/2015/09/15/styling-customizing-file-inputs-smart-way/ */

      var hiddenInputStyle = {
        width: '0.1px',
        height: '0.1px',
        opacity: 0,
        overflow: 'hidden',
        position: 'absolute',
        zIndex: -1
      };
      var restrictions = uppy.opts.restrictions;
      return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        key: "uppy-div",
        className: "uppy-Root uppy-SingleFileUppy-container"
      }, /*#__PURE__*/_react["default"].createElement("input", {
        className: "uppy-SingleFileUppy-input",
        style: hiddenInputStyle,
        type: "file",
        name: "inputName",
        onChange: this.handleInputChange,
        multiple: restrictions.maxNumberOfFiles !== 1,
        accept: restrictions.allowedFileTypes,
        ref: function ref(input) {
          _this3.input = input;
        },
        value: ""
      })), children ? children({
        key: 'uppy-fileinput',
        onClick: function onClick() {
          _this3.startUpload();
        },
        progress: progress,
        uploading: uploading
      }) : '');
    }
  }]);

  return SingleFileUppy;
}(_react["default"].Component);

SingleFileUppy.propTypes = {
  children: _propTypes["default"].func.isReauired,
  uppy: _propTypes["default"].instanceOf(_core.Uppy).isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = SingleFileUppy;
exports["default"] = _default;